import { createActions, createReducer } from 'reduxsauce';
import { combineReducers } from 'redux';

export const { Types: types, Creators: actions } = createActions(
  {
    sendContactMessage: ['payload'],
    sendContactMessageRequest: [],
    sendContactMessageSuccess: [],
    sendContactMessageFailure: ['error'],
    resetContactMessageState: [],
  },
  { prefix: 'cb/email/' },
);

export const INITIAL_STATE = {
  fetching: false,
  error: null,
};

export default combineReducers({
  fetching: createReducer(INITIAL_STATE.fetching, {
    [types.SEND_CONTACT_MESSAGE_REQUEST]: () => true,
    [types.SEND_CONTACT_MESSAGE_SUCCESS]: () => INITIAL_STATE.fetching,
    [types.SEND_CONTACT_MESSAGE_FAILURE]: () => INITIAL_STATE.fetching,
  }),
  error: createReducer(INITIAL_STATE.error, {
    [types.SEND_CONTACT_MESSAGE_REQUEST]: () => INITIAL_STATE.error,
    [types.SEND_CONTACT_MESSAGE_FAILURE]: (_, { error }) => error,
    [types.RESET_CONTACT_MESSAGE_STATE]: () => INITIAL_STATE.error,
  }),
});